import { apiFetch } from './api-client';

export type DriverNotificationDTO = {
  id: string;
  type: string;
  category: 'TRIP' | 'COMPLIANCE' | 'PAYMENT' | 'SYSTEM';
  title: string;
  body: string;
  link: string | null;
  readAt: string | null;
  createdAt: string;
};

export type ListNotificationsResponse = {
  items: DriverNotificationDTO[];
  nextCursor: string | null;
};

export function listNotifications(cursor?: string, limit?: number): Promise<ListNotificationsResponse> {
  const params = new URLSearchParams();
  if (cursor) params.set('cursor', cursor);
  if (limit !== undefined) params.set('limit', String(limit));
  const qs = params.toString();
  const url = qs ? `/driver-app/me/notifications?${qs}` : '/driver-app/me/notifications';
  return apiFetch(url) as Promise<ListNotificationsResponse>;
}

export function markRead(ids: string[]): Promise<void> {
  return apiFetch('/driver-app/me/notifications/read', {
    method: 'POST',
    body: JSON.stringify({ ids }),
  }) as Promise<void>;
}

export function markAllRead(): Promise<void> {
  return apiFetch('/driver-app/me/notifications/read-all', {
    method: 'POST',
  }) as Promise<void>;
}

export async function getUnreadCount(): Promise<number> {
  const res = (await apiFetch('/driver-app/me/notifications/unread-count')) as { count: number };
  return res.count;
}
